import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SnapshotIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="snapshot" ref={ref} {...props}>
      <path d="M9,21.86H4.91a2.75,2.75,0,0,1-2.75-2.75V15a.75.75,0,0,1,1.5,0v4.11a1.26,1.26,0,0,0,1.25,1.25H9a.75.75,0,0,1,0,1.5ZM3.66,9V4.94A1.26,1.26,0,0,1,4.91,3.69H9a.75.75,0,0,0,0-1.5H4.91A2.76,2.76,0,0,0,2.16,4.94V9a.75.75,0,0,0,1.5,0ZM21.83,9V4.94a2.75,2.75,0,0,0-2.75-2.75H15a.75.75,0,0,0,0,1.5h4.08a1.25,1.25,0,0,1,1.25,1.25V9a.75.75,0,0,0,1.5,0Zm0,10.11V15a.75.75,0,0,0-1.5,0v4.11a1.25,1.25,0,0,1-1.25,1.25H15a.75.75,0,0,0,0,1.5h4.08A2.75,2.75,0,0,0,21.83,19.11ZM16.75,12A4.75,4.75,0,1,0,12,16.78,4.75,4.75,0,0,0,16.75,12Zm-1.5,0A3.25,3.25,0,1,1,12,8.78,3.26,3.26,0,0,1,15.25,12Z" />
    </Icon>
  ),
) as IconWithRender;

SnapshotIcon.displayName = 'SnapshotIcon';
SnapshotIcon.renderIcon = (props) => <SnapshotIcon {...props} />;
export default SnapshotIcon;
